import React from 'react'

const PlaySmIcon = ({ width = 14, height = 14, className }) => (
  <svg width={width} height={height} viewBox="0 0 14 14" className={className}>
    <polygon points="5 2 5 12 12 7 5 2" />
  </svg>
)

export default PlaySmIcon
